import React, { useReducer, useEffect, useCallback, useMemo } from 'react'
import { useSnackbar } from 'notistack'
import { termsAcceptanceInitialState } from './store/State'
import termsAcceptanceReducer from './store/Reducer'
import TermsAcceptanceService from './Service'
import IUserData from 'types/sign-in/IUserData'
import { ITermsAcceptanceProps } from './Interfaces'

// import WithRequireAuthenticationService from 'hocs/with-require-authentication/Service'
// import { navigate } from '@reach/router'
import SessionManagerService from 'smart-components/session-manager/Service'

const termsAcceptanceContext = {
  state: termsAcceptanceInitialState,
  handlers: {
    acceptTerms: () => new Promise<void>(() => {}),
    rejectTerms: (_password: string) => new Promise<void>(() => {})
  }
}

export type TermsAcceptanceContext = typeof termsAcceptanceContext

export const TermsAcceptanceContextProvider = React.createContext<TermsAcceptanceContext>(termsAcceptanceContext)

const Provider: React.FC<ITermsAcceptanceProps> = ({ routeId, children }) => {
  const [state, dispatch] = useReducer(termsAcceptanceReducer, termsAcceptanceInitialState)
  const { enqueueSnackbar } = useSnackbar()

  const onError = useCallback(
    (error: string) => {
      enqueueSnackbar(error, {
        variant: 'warning',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
    },
    [enqueueSnackbar]
  )

  const onAcceptTermsSuccess = useCallback(
    (user: IUserData) => {
      SessionManagerService.setCurrentUser(user)

      // const [shouldRedirect, path] = WithRequireAuthenticationService.decideNextRoute(user, routeId, '/top-fives')

      // if (shouldRedirect) {
      //   navigate(path)
      // }
    },
    [routeId]
  )

  const onRejectTermsSuccess = useCallback(() => {
    SessionManagerService.logOff()
  }, [])

  const handlers = useMemo(
    () => ({
      acceptTerms: TermsAcceptanceService.acceptTerms(state, dispatch, onAcceptTermsSuccess, onError),
      rejectTerms: TermsAcceptanceService.rejectTerms(state, dispatch, onRejectTermsSuccess, onError)
    }),
    [onAcceptTermsSuccess, onError, onRejectTermsSuccess, state]
  )

  const contextValue = {
    ...termsAcceptanceContext,
    state,
    handlers
  }

  useEffect(() => {
    async function loadTermsAndPrivacy() {
      await TermsAcceptanceService.loadTermsAndConditions(state, dispatch)
      await TermsAcceptanceService.loadPrivacyPolicy(state, dispatch)
    }

    if (!state.isLoadingData && !state.privacyPolicy && !state.termsAndConditions) {
      loadTermsAndPrivacy()
    }
  }, [])

  return (
    <TermsAcceptanceContextProvider.Provider value={contextValue}>{children}</TermsAcceptanceContextProvider.Provider>
  )
}

export default React.memo(Provider)
